module.exports = __webpack_public_path__ + "img/failMsg.2462b2ad.svg";